<script lang="ts">
  import {
    hcSheetState,
    HcSheetView,
    isSecondLevelView,
    requestHcSheetBack,
    requestHcSheetClose,
  } from "./hcSheetState.svelte";

  const open = $derived(hcSheetState.open);
  const secondLevel = $derived(isSecondLevelView(hcSheetState.view));

  $effect(() => {
    if (open) {
      /*                              */
      const body = document.body;
      const scrollY = window.scrollY;
      const previous = {
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        height: body.style.height,
        overflow: body.style.overflow,
      };

      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
      body.style.height = `${window.innerHeight + scrollY}px`;
      body.style.overflow = "hidden";

      return () => {
        body.style.position = previous.position;
        body.style.top = previous.top;
        body.style.left = previous.left;
        body.style.right = previous.right;
        body.style.width = previous.width;
        body.style.height = previous.height;
        body.style.overflow = previous.overflow;
        window.scrollTo(0, scrollY);
      };
    }
  });

  function onKeydown(event: KeyboardEvent) {
    if (event.key === "Escape" && open) {
      requestHcSheetClose();
    }
  }
</script>

<svelte:window on:keydown={onKeydown} />

<div class="hc_sheet" class:hc_sheet--open={open} aria-hidden={!open}>
  <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_static_element_interactions -->
  <div class="hc_sheet__backdrop" onclick={requestHcSheetClose}></div>

  <section
    id="heureka-hc-filtersheet"
    class="hc_sheet__panel heureka_filterSheet"
    class:hc_sheet__panel--full-height={hcSheetState.view !== HcSheetView.SecondLevelNbf}
    class:heureka_filterSheet--level-second={secondLevel}
    class:heureka_filterSheet--level-second-nbf={hcSheetState.view === HcSheetView.SecondLevelNbf}
    class:hc_sheet__panel--navigation={hcSheetState.view === HcSheetView.Navigation}
    role="dialog"
    aria-modal="true"
    aria-label={secondLevel ? hcSheetState.secondLevelHeadline : hcSheetState.title || "Filter"}
  >
    <header class="hc_sheet__header">
      {#if secondLevel}
        <oc-icon-button-v3
          class="hc_sheet__back js_filterSheetAction"
          oc-aria-label="Zurück"
          icon="arrow-left"
          size="50"
          variant="transparent"
          onclick={requestHcSheetBack}
        ></oc-icon-button-v3>
        <h2 class="hc_sheet__title">{hcSheetState.secondLevelHeadline}</h2>
      {:else}
        <h2 class="hc_sheet__title">{hcSheetState.title}</h2>
      {/if}

      <oc-icon-button-v3
        class="hc_sheet__close"
        oc-aria-label="Schließen"
        icon="close"
        size="50"
        variant="transparent"
        onclick={requestHcSheetClose}
      ></oc-icon-button-v3>
    </header>

    <div class="hc_sheet__content heureka_filterSheet__content"></div>
    <footer class="hc_sheet__actions heureka_filterSheet__actions"></footer>
  </section>
</div>

<style>
  .hc_sheet {
    position: fixed;
    inset: 0;
    z-index: 1000;
    /**
 *
 *
 */
    visibility: hidden;
    pointer-events: none;
    transition: visibility 0s linear 250ms;
  }

  .hc_sheet--open {
    visibility: visible;
    pointer-events: auto;
    /*                                                                            */
    transition: visibility 0s;
  }

  .hc_sheet__backdrop {
    position: absolute;
    inset: 0;
    background-color: var(--oc-semantic-color-overlay-scrim, rgba(33, 33, 33, 0.65));
    opacity: 0;
    transition: opacity 250ms ease;
  }

  .hc_sheet--open .hc_sheet__backdrop {
    opacity: 1;
  }

  .hc_sheet__panel {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    /*                                                                       */
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    background-color: var(--oc-semantic-color-above-background, #fff);
    border-top-left-radius: var(--oc-semantic-border-radius-200, 12px);
    border-top-right-radius: var(--oc-semantic-border-radius-200, 12px);
    box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.15);
    /*                                                                         */
    transform: translateY(100%);
    transition: transform 250ms ease;
    overscroll-behavior: contain;
  }

  /**
 */
  .hc_sheet__panel--full-height {
    height: calc(95 * 1dvh - var(--keyboard-height, 0px));
    max-height: calc(95 * 1dvh - var(--keyboard-height, 0px));
  }

  .hc_sheet--open .hc_sheet__panel {
    transform: translateY(0);
  }

  .hc_sheet__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--oc-semantic-spacing-50, 8px);
    padding: var(--oc-base-dimension-relative-16, 16px);
    font: var(--oc-semantic-font-headline-100);
  }

  .hc_sheet__title {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
  }

  .hc_sheet__back {
    flex: 0 0 auto;
    order: -1;
  }

  .heureka_filterSheet--level-second-nbf .hc_sheet__back {
    display: none;
  }

  .hc_sheet__close {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
  }

  .hc_sheet__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .hc_sheet__actions {
    display: flex;
    gap: var(--oc-semantic-spacing-50, 8px);
    padding: var(--oc-base-dimension-relative-16, 16px);
  }

  .hc_sheet__actions:empty {
    display: none;
  }

  .hc_sheet__panel--navigation :global(.heureka_filterTitles) {
    display: none;
  }

  .hc_sheet__panel--navigation .hc_sheet__actions {
    display: none;
  }

  /**
 *
 */
  @media (min-width: 480px) {
    .hc_sheet__panel {
      top: 0;
      bottom: 0;
      left: initial;
      right: 0;
      width: var(--oc-base-breakpoint-m, 30rem);
      max-width: var(--oc-base-breakpoint-m, 30rem);
      max-height: none;
      /*                                                                 */
      transform: translateX(100%);
      border-radius: var(--oc-semantic-border-radius-300, 16px);
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .hc_sheet--open .hc_sheet__panel {
      transform: translateX(0);
    }

    /*                                                                                          */
    .hc_sheet__panel--full-height {
      height: auto;
      max-height: 100dvh;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .hc_sheet,
    .hc_sheet--open,
    .hc_sheet__backdrop,
    .hc_sheet__panel {
      transition: none;
    }
  }
</style>
